import Quill from "quill";

const Embed = Quill.import("blots/embed");

class AutoRuleBlot extends Embed {
  static blotName = "rule";
  static tagName = "span";

  static create(rule) {
    const node = super.create();
    if (!rule.id) return node;
    const { name, id } = typeof rule === "object" ? rule : { name: "", id: "" };
    node.classList.add("autorule-token-blot");
    node.setAttribute("data-rule", name);
    node.setAttribute("data-id", id);
    node.innerText = name;
    return node;
  }

  static value(node) {
    return {
      token: node.getAttribute("data-rule"),
      label: node.getAttribute("data-id"),
    };
  }
}

class RuleDelimeterBlot extends Embed {
  static blotName = "ql-rule-delimeter";
  static tagName = "span";

  static create(delimeterText) {
    const node = super.create();
    node.classList.add("rule-deliemter-blot");
    node.setAttribute("data-text", delimeterText);
    node.innerText = "%";
    return node;
  }
  static value() {}
}

// Prevent duplicate registration in dev or HMR
if (
  typeof window !== "undefined" &&
  Quill?.register &&
  !Quill.import["formats/rule"]
) {
  Quill.register(AutoRuleBlot, true);
  Quill.register(RuleDelimeterBlot, true);
}

export default AutoRuleBlot;
